import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Injectable, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogConfig, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';

export interface ConfirmOptions {
  title?: string;
  message?: string;
  warning?: boolean;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'to-confirm',
  templateUrl: './confirm.html',
  styleUrls: ['./confirm.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmOptions,
  ) { }
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  constructor(
    private dialog: MatDialog,
  ) { }

  public open(data: ConfirmOptions, config: MatDialogConfig<any> = {}) {
    return this.dialog.open(ConfirmComponent, {
      ...{
        width: '300px',
        panelClass: 'confirm-panel',
        autoFocus: false,
        disableClose: true,
      },
      ...config,
      data: data,
    });
}
}

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    FontAwesomeModule,
  ],
  declarations: [ConfirmComponent],
  entryComponents: [ConfirmComponent],
})
export class ConfirmModule {
  constructor(
    library: FaIconLibrary,
  ) {
    library.addIcons(faExclamationTriangle);
  }
}
